import { render, staticRenderFns } from "./Duel_Post_Header.vue?vue&type=template&id=5773a4f9&"
import script from "./Duel_Post_Header.vue?vue&type=script&lang=js&"
export * from "./Duel_Post_Header.vue?vue&type=script&lang=js&"
import style0 from "./Duel_Post_Header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports